<!-- <div> -->
 <ng-template [ngIf]="updateDocVersionForm">
<div class="col-sm-12 coldx" ngbTooltip="" triggers="manual" #updateTooltip="ngbTooltip">
	<h4>Upload nuova versione documento</h4>
	<form [formGroup]="updateDocVersionForm" (ngSubmit)="saveDocumentMetadata()">
		<div class="row">
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Posizione'" [valueInput]="documento.posizione"></div>
			<div labelTextInput class="col-sm-8 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Titolo'" [valueInput]="documento.titolo"></div>
		</div>
		<hr>
		<div class="row">
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Tipo'" [valueInput]="documento.tipoDocumento?.descrizione"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Provenienza'" [valueInput]="documento.provenienza?.descrizione"></div>
			<div datePickerInput class="col-sm-4" [labelInput]="'Data riferimento'" formControlName="dataRiferimento"
				[(ngModel)]="documento.dataRiferimento" [mandatory]="true"
				[control]="updateDocVersionForm.controls['dataRiferimento']">
			</div>
		</div>
		<hr>
		<div class="row">
			<div ng-select-combo class="col-sm-6" formControlName="tipoVisibilitaDocumento" [label]="'Visibilità documento'" [required]="true"
				[options]="tipiVisibilitaDocumento" [optionSel]="documento.tipoVisibilitaDocumento"
				(onChangeSel)="documento.tipoVisibilitaDocumento = $event; ">
			</div>
		</div>
		<hr>
		<div class="row">
			<div textAreaInput class="col-sm-12" [labelInput]="'Motivo della revisione'"
				formControlName="note"></div>
		</div>
		<div class="row align-items-start">
			<div class="col-sm-10">

				<div class="tg" *ngIf="documentoAllegatoPerForm">
				<app-document-uploaded
					[indexFile]="0"
					[file]="documentoAllegatoPerForm"
					(onReturn)="onDocReturn($event)"
					(onRemoveFile)="deleteFile($event)" 
					[tipiDocumentoOptions]="tipiDocumento"
					[protocol]="false"
					[nuovaVersione]="true">
				</app-document-uploaded>
				</div>
			</div>
			<div class="col-sm-2 d-flex justify-content-end">
				<app-upload-tool
					[standard]="true"
					[disabled]="!!documentoAllegatoPerForm"
					[multiple]="false"
					(onChange)="onFileSelected($event)">
				</app-upload-tool>
			</div>
		</div>
		<hr style="visibility: hidden;">
		<div class="row">
			<p class="col-sm-3 col-xs-6">
				<button type="button" class="btn btn-outline-secondary btn-block"
					(click)="createForm(documento);">Reset</button>
			</p>
			<p submitButton
				class="col-sm-3 col-xs-6 col-sm-offset-6"
				[labelButton]="'Inserisci e Salva'" [disabled]="disableSubmit 
				|| !updateDocVersionForm?.valid"></p>
		</div>
	</form>
</div>
</ng-template>
<!-- </div> -->